/* eslint-disable react/no-unknown-property */
import { formatDate } from '@doveit/hammer';
import { format, isToday, isTomorrow } from 'date-fns';
import React from 'react';
import { TokenColor } from '@doveit/bricks';
import * as styles from './DateViewer.style';

export type HighlightColorType = keyof TokenColor['foreground'];

export interface DateViewerProps {
  stringDate: string;
  checkIfToday?: boolean;
  checkIfTomorrow?: boolean;
  withStrong?: boolean;
  withHour?: boolean;
  highlightWhen?: (date: Date) => HighlightColorType | undefined;
}

const DateViewer: React.FC<DateViewerProps> = ({
  stringDate,
  checkIfToday = false,
  checkIfTomorrow = false,
  withStrong = false,
  withHour = false,
  highlightWhen,
}): React.ReactElement => {
  const date = React.useMemo(() => new Date(stringDate), [stringDate]);
  const hour = format(date, 'HH:mm');
  const highlightColor = React.useMemo(() => highlightWhen?.(date), [highlightWhen, date]);

  if (checkIfToday && isToday(date)) {
    return withStrong ? (
      <span css={styles.noWrap}>
        <strong aria-label="strong-date"> Oggi </strong>
        {withHour && <> - <span aria-label="hour">{hour}</span> </>}
      </span>
    ) : <span css={styles.noWrap}> Oggi {withHour && <>- {hour} </>}</span>;
  }

  if (checkIfTomorrow && isTomorrow(date)) {
    return withStrong ? (
      <div css={styles.noWrap}>
        <strong aria-label="strong-date"> Domani </strong>
        {withHour && <> - <span aria-label="hour">{hour}</span> </>}
      </div>
    )
      : <span css={styles.noWrap}> Domani {withHour && <> - {hour} </>} </span>;
  }

  return withHour
    ? (
      <span css={styles.noWrap} $highlightColor={highlightColor}>
        {formatDate(date)} - {hour}
      </span>
    ) : (
      <span css={styles.noWrap} $highlightColor={highlightColor}>
        {formatDate(date)}
      </span>
    );
};

export default DateViewer;
